module.exports = __webpack_public_path__ + "img/slide-38.375ff3b4.jpeg";